<template>
  <div>
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <!-- <div class="col-md-1">
              <i style="font-size: 80px; color: grey" class="fa fa-search"></i>
            </div> -->
            <div class="col-md-11">
              <h4 style="font-weight: bold;">
                Buscar Ordenes y Autorizaciones
              </h4>
              <p
                style="margin-top:-15px; color: grey; font-weight: 500; font-size: 15px;"
              >
                Registro y busqueda de servicios
              </p>
            </div>
          </div>
        </div>
        <div class="card-content">
          <button
            class="btn btn-success btn-fill"
            style="border-radius: 5px"
            @click="abrirModal()"
          >
            <i class="fa fa-plus"></i> Ingreso de servicio
          </button>
        </div>
        <div class="row">
          <ordenes></ordenes>
        </div>
        <div></div>
      </div>
    </div>

    <modal
      name="ingreso_servicio"
      id="modal"
      height="80%"
      width="900px"
      :scrollable="true"
      :reset="true"
      :clickToClose="false"
    >
      <div>
        <div>
          <div class="card-header">
            <div>
              <span style="font-size: 17px; font-weight: 500;">Ingreso de servicios</span>
            </div>
            <button
              @click="cerrarModal()"
              type="button"
              class="btn btn-danger btn-simple btn-icon"
              data-dismiss="modal"
              aria-label="Close"
              
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body scroll-gg">
            <div class="row">
              <div class="col-md-6">
                <label for="tipoCliente">Tipo de cliente</label>
                <select
                  @change="asignarTipoCliente()"
                  v-model="tipoCliente"
                  id="tipoCliente"
                  class="form-control"
                >
                  <option value="6">EPS</option>
                  <option value="7">Prepagada</option>
                  <option value="8">Póliza</option>
                  <option value="2">Particular</option>
                  <!-- <option value="3">Convenio</option> -->
                </select>
              </div>
            </div>
            <br />
            <div v-if="tipoCliente == 6">
              <eps :modal="modalRegistrar"></eps>
            </div>
            <div v-if="tipoCliente == 7">
              <prepagada></prepagada>
            </div>
            <div v-if="tipoCliente == 8">
              <poliza></poliza>
            </div>
            <div v-if="tipoCliente == 2">
              <particular></particular>
            </div>
            <div v-if="tipoCliente == 3">
              <convenio></convenio>
            </div>
          </div>
          <!-- <center>
            <button type="button" class="btn btn-danger btn-sm" @click="modalRegistrar=0">Cancelar</button>
          </center> -->
          <br />
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from "axios";
import eps from "../Admisiones/formularios/eps.vue";
import prepagada from "../Admisiones/formularios/prepagada.vue";
import convenio from "../Admisiones/formularios/convenio.vue";
import poliza from "../Admisiones/formularios/poliza.vue";
import particular from "../Admisiones/formularios/particular.vue";
import ordenes from "../Admisiones/ordenes/ordenes.vue";
export default {
  data() {
    return {
      modalRegistrar: 0,
      tipoCliente: 6,
      time: 0,
      duration: 5000
    };
  },
  methods: {
    abrirModal() {
      this.modalRegistrar = 1;
      this.$modal.show("ingreso_servicio");
    },
    cerrarModal() {
      this.$modal.hide("ingreso_servicio");
    },
    asignarTipoCliente() {
      localStorage.setItem("tipoClienteIngreso", this.tipoCliente);
    }
  },
  components: {
    eps,
    prepagada,
    poliza,
    particular,
    ordenes,
    convenio
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.asignarTipoCliente();
    }
  }
};
</script>
<style scoped>
#modal {
  padding-left: 10%;
  /* position: absolute; */
}
p {
  font-size: 13px;
}
.card {
  border-radius: 10px;
  padding: 1%;
}
.scroll-gg {
  width: 100%;
  height: 630px;

  overflow: auto;
}

.card-header {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Admisiones/ingresoServicios.vue